import type { ComponentProps, FunctionComponent, JSX } from 'react'
import { StyleSheet, View } from 'react-native'
import type { SvgProps } from 'react-native-svg'
import { mesaColorNames } from '@/src/common/theme'

export function BoxedIcon(
  props: (
    | { Icon: FunctionComponent<Pick<SvgProps, 'width' | 'height' | 'style'>> }
    | { icon: JSX.Element }
  ) &
    Pick<ComponentProps<typeof View>, 'style' | 'children'>,
) {
  return (
    <View style={[styles.iconContainer, props.style]}>
      {'Icon' in props ? (
        <props.Icon width={20} height={20} style={{ margin: 'auto' }} />
      ) : (
        props.icon
      )}
      {props.children}
    </View>
  )
}

const styles = StyleSheet.create({
  iconContainer: {
    backgroundColor: mesaColorNames['Wide/100 #C6FFF5'],
    width: 36,
    height: 36,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})
